import { useState } from 'react'

import { FamilyMember } from 'core'

import { DefaultSelectV2 } from 'common/components'

type Props = {
  name: string
  isForSelf: boolean
  familyMembers: FamilyMember[]
}

const SelectExpenseForDependent = ({ name, isForSelf, familyMembers }: Props) => {
  const dependents = (() => {
    const defaults = isForSelf ? [] : [{ id: 'me', name: 'Me' }]
    return [
      ...defaults,
      ...familyMembers?.map(({ id, firstName, lastName }) => ({ id, name: `${firstName} ${lastName}` })),
    ]
  })()

  return (
    <DefaultSelectV2
      name={name}
      mode="multiple"
      label="Who else is covered by this policy?"
      placeholder="Select a dependent"
      items={dependents}
    />
  )
}

export default SelectExpenseForDependent
